import { asDarkSvg, asDisabledSvg, asLightSvg } from '../../hocs';
import SidebarFixedPositionSvg from './SidebarFixedPositionSvg';

const LightSidebarFixedPositionSvg = asLightSvg(SidebarFixedPositionSvg);
const DarkSidebarFixedPositionSvg = asDarkSvg(SidebarFixedPositionSvg);
const DisabledSidebarFixedPositionSvg = asDisabledSvg(SidebarFixedPositionSvg);

export default SidebarFixedPositionSvg;
export {
    SidebarFixedPositionSvg,
    LightSidebarFixedPositionSvg,
    DarkSidebarFixedPositionSvg,
    DisabledSidebarFixedPositionSvg,
};
